<template>
    <div class="herds-view">
        <div class="herds-grid">
            <!-- Stan ladowania: szkielety kart, zeby widok nie byl pusty zaraz po wejsciu. -->
            <template v-if="loading">
                <div v-for="n in skeletonsCount" :key="'skeleton-' + n" class="herd-card-skeleton">
                    <div class="skeleton-line"></div>
                    <chart-skeleton :height="chartHeight"/>
                </div>
            </template>

            <template v-else>
                <system-herd-weight-card
                    v-for="system in systems"
                    :key="system.id"
                    :system="system"
                    :chartHeight="chartHeight"/>
            </template>
        </div>

        <!-- Stan bledu: lista systemow sie nie pobrala. -->
        <div v-if="!loading && error" class="herds-view__state">
            <span>{{ $t('SystemsLoadFailed') }}</span>
            <button type="button" class="herds-view__retry" @click="getData">{{ $t('Retry') }}</button>
        </div>

        <!-- Stan pusty: brak systemow z waga stada. -->
        <div v-else-if="!loading && systems.length == 0" class="herds-view__state">
            <span>{{ $t('NoSystemsWithWeight') }}</span>
        </div>
    </div>
</template>

<script>
import { getSystemsStatusList } from "@api";
import SystemHerdWeightCard from '../components/Systems/SystemHerdWeightCard.vue';
import ChartSkeleton from '../components/Charts/ChartSkeleton.vue';

export default {
    name: 'HerdsWeightView',
    components: {
        SystemHerdWeightCard,
        ChartSkeleton
    },
    data() {
        return {
            systems: [],
            loading: true,
            error: false,
            chartHeight: 260,
            skeletonsCount: 6
        }
    },
    methods: {
        async getData() {
            this.loading = true;
            this.error = false;

            try {
                const result = await getSystemsStatusList();
                this.systems = result.filter(x => x.hasWeight).sort(this.sortSystemsByName);
            } catch (e) {
                console.error(e);
                this.systems = [];
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
        sortSystemsByName(a, b){
			return (a.name.localeCompare(b.name, undefined, {
              numeric: true,
              sensitivity: 'base'
            }));
		},
    },
    mounted: async function() {
        this.getData();
    }
}
</script>

<style scoped>
.herds-view {
    padding: 10px 20px;
    max-height: calc(100vh - 70px);
    overflow-y: auto;
}

/* Najwyżej trzy wykresy w rzędzie, rozciągnięte na całą szerokość: kolumna ma co
   najmniej 1/3 siatki (minus dwa odstępy po 15px), więc czwarta się nie mieści.
   Gdy 1/3 to mniej niż 300px, zostają dwie kolumny, a na wąskim ekranie jedna. */
.herds-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, max(300px, calc((100% - 30px) / 3))), 1fr));
    gap: 15px;
}

.herd-card-skeleton {
    padding: 10px 12px;
    background: #414F51;
    border: 1px solid #30383a;
    border-radius: 5px;
}

.skeleton-line {
    width: 40%;
    height: 16px;
    margin-bottom: 10px;
    border-radius: 4px;
    background: linear-gradient(90deg, #4d5b5d 25%, #5c6b6d 37%, #4d5b5d 63%);
    background-size: 400% 100%;
    animation: skeleton-loading 1.4s ease infinite;
}

@keyframes skeleton-loading {
    0% { background-position: 100% 50%; }
    100% { background-position: 0 50%; }
}

.herds-view__state {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    color: gray;
    font-size: 16px;
    text-align: center;
    padding: 40px 10px;
}

.herds-view__retry {
    color: white;
    background: #414F51;
    border: 1px solid #30383a;
    border-radius: 5px;
    padding: 5px 15px;
    font-size: 14px;
    cursor: pointer;
}

.herds-view__retry:hover {
    background: #30383a;
}
</style>



// WEBPACK FOOTER //
// src/views/HerdsWeightView.vue